import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Button, Typography } from 'antd';

// Global UI prompt for PWA updates
// Listens for window event 'sw-update-available' dispatched from src/main.jsx
// When user clicks Update, we dispatch 'sw-accept-update' so main can call SKIP_WAITING

// Detect iOS
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const COOLDOWN_MS = isIOS ? 10 * 60 * 1000 : 60 * 60 * 1000; // 10 mins on iOS, 60 mins otherwise
const COOLDOWN_KEY = 'swUpdateCooldownUntil';

const UpdateAvailablePrompt = () => {
  const [open, setOpen] = useState(false);

  const canShow = useCallback(() => {
    try {
      const until = Number(localStorage.getItem(COOLDOWN_KEY) || 0);
      return Date.now() > until;
    } catch {
      return true;
    }
  }, []);

  const onUpdate = () => {
    // Let main.jsx perform SKIP_WAITING and reload when controller changes
    window.dispatchEvent(new Event('sw-accept-update'));
    setOpen(false);
  };

  const onLater = () => {
    try {
      localStorage.setItem(COOLDOWN_KEY, String(Date.now() + COOLDOWN_MS));
    } catch {}
    setOpen(false);
  };

  useEffect(() => {
    const handler = () => {
      if (canShow()) setOpen(true);
    };
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, [canShow]);

  return (
    <Modal
      open={open}
      title="Update Available"
      onCancel={onLater}
      footer={[
        <Button key="later" onClick={onLater}>
          Later
        </Button>,
        <Button key="update" type="primary" onClick={onUpdate}>
          Update now
        </Button>,
      ]}
      centered
      destroyOnHidden
    >
      <Typography.Paragraph>
        A new version of the app is available. Updating will reload the app to the latest version.
      </Typography.Paragraph>
    </Modal>
  );
};

export default UpdateAvailablePrompt;
